export var ReactionType;
(function (ReactionType) {
    ReactionType["LIKE"] = "like";
    ReactionType["CELEBRATE"] = "celebrate";
    ReactionType["SUPPORT"] = "support";
    ReactionType["INSIGHTFUL"] = "insightful";
    ReactionType["CURIOUS"] = "curious";
})(ReactionType || (ReactionType = {}));
export var PostVisibility;
(function (PostVisibility) {
    PostVisibility["PUBLIC"] = "public";
    PostVisibility["CONNECTIONS"] = "connections";
})(PostVisibility || (PostVisibility = {}));
export var PostMediaType;
(function (PostMediaType) {
    PostMediaType["IMAGE"] = "image";
    PostMediaType["LINK"] = "link";
})(PostMediaType || (PostMediaType = {}));
export var FeedSocketEvent;
(function (FeedSocketEvent) {
    FeedSocketEvent["POST_CREATED"] = "feed:post_created";
    FeedSocketEvent["POST_UPDATED"] = "feed:post_updated";
    FeedSocketEvent["POST_DELETED"] = "feed:post_deleted";
    FeedSocketEvent["COMMENT_CREATED"] = "feed:comment_created";
    FeedSocketEvent["COMMENT_DELETED"] = "feed:comment_deleted";
    FeedSocketEvent["REACTION_CHANGED"] = "feed:reaction_changed";
})(FeedSocketEvent || (FeedSocketEvent = {}));
export var FeedSocketClientEvent;
(function (FeedSocketClientEvent) {
    FeedSocketClientEvent["SUBSCRIBE_POST"] = "feed:subscribe_post";
    FeedSocketClientEvent["UNSUBSCRIBE_POST"] = "feed:unsubscribe_post";
})(FeedSocketClientEvent || (FeedSocketClientEvent = {}));
//# sourceMappingURL=feed.enum.js.map